/* Amalife wishlist — localStorage-based favourites. No app, no login required.
   - toggle buttons:  [data-ama-wish] with data-handle/id/title/url/image/price
   - header count:    .ama-wishlist-count
   - favourites page: [data-ama-wish-grid] + [data-ama-wish-empty]
*/
(function () {
  var KEY = 'ama:wishlist';

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
  }
  function write(arr) {
    try { localStorage.setItem(KEY, JSON.stringify(arr)); } catch (e) {}
    updateCounts();
  }
  function has(handle) {
    return read().some(function (i) { return i.handle === handle; });
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function toggle(data) {
    var arr = read();
    var idx = -1;
    for (var i = 0; i < arr.length; i++) { if (arr[i].handle === data.handle) { idx = i; break; } }
    if (idx > -1) { arr.splice(idx, 1); } else { arr.unshift(data); }
    write(arr);
    return idx < 0; // true = added
  }

  function updateCounts() {
    var n = read().length;
    document.querySelectorAll('.ama-wishlist-count').forEach(function (el) {
      el.textContent = n;
      el.hidden = n === 0;
    });
  }

  function syncButtons() {
    document.querySelectorAll('[data-ama-wish]').forEach(function (b) {
      var on = has(b.dataset.handle);
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.setAttribute('aria-label', on ? (window.amaI18n && window.amaI18n.remove_wishlist || 'Премахни от любими') : (window.amaI18n && window.amaI18n.add_wishlist || 'Добави в любими'));
    });
  }

  function renderPage() {
    var grid = document.querySelector('[data-ama-wish-grid]');
    if (!grid) return;
    var items = read();
    var empty = document.querySelector('[data-ama-wish-empty]');
    if (!items.length) {
      grid.innerHTML = '';
      if (empty) empty.hidden = false;
      return;
    }
    if (empty) empty.hidden = true;
    grid.innerHTML = items.map(function (i) {
      return '<article class="ama-wcard">' +
        '<a class="ama-wcard__media" href="' + esc(i.url) + '">' +
          (i.image ? '<img src="' + esc(i.image) + '" alt="' + esc(i.title) + '" loading="lazy">' : '') +
        '</a>' +
        '<div class="ama-wcard__body">' +
          '<a class="ama-wcard__title" href="' + esc(i.url) + '">' + esc(i.title) + '</a>' +
          (i.price ? '<div class="ama-wcard__price">' + esc(i.price) + '</div>' : '') +
          '<button type="button" class="ama-wcard__remove" data-ama-wish-remove="' + esc(i.handle) + '">' + esc(window.amaI18n && window.amaI18n.remove || 'Премахни') + '</button>' +
        '</div>' +
      '</article>';
    }).join('');
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ama-wish]');
    if (btn) {
      e.preventDefault();
      var added = toggle({
        handle: btn.dataset.handle, id: btn.dataset.id, title: btn.dataset.title,
        url: btn.dataset.url, image: btn.dataset.image, price: btn.dataset.price
      });
      btn.classList.toggle('is-active', added);
      btn.setAttribute('aria-pressed', added ? 'true' : 'false');
      btn.setAttribute('aria-label', added ? (window.amaI18n && window.amaI18n.remove_wishlist || 'Премахни от любими') : (window.amaI18n && window.amaI18n.add_wishlist || 'Добави в любими'));
      return;
    }
    var rm = e.target.closest('[data-ama-wish-remove]');
    if (rm) {
      var h = rm.getAttribute('data-ama-wish-remove');
      write(read().filter(function (x) { return x.handle !== h; }));
      renderPage();
      syncButtons();
    }
  });

  function init() { updateCounts(); syncButtons(); renderPage(); }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  // keep buttons in sync if products load late (e.g. quick-view / filters)
  document.addEventListener('shopify:section:load', function () { syncButtons(); renderPage(); });
})();
